import React, { useEffect } from "react";
import { Grid, TextInput, Text } from "@mantine/core";
import {
  normalizeOrderArFormAccount,
  resolveOrderIfastAccountNo,
  setOrderIfastAccountNo,
} from "../helpers/arFormUtils";

const SummaryItem = ({ label, value }) => (
  <div>
    <Text size="xs" color="dimmed" mb={2}>
      {label}
    </Text>
    <Text size="sm">{value || "—"}</Text>
  </div>
);

const OrderInvestmentAccount = ({ form, orderSource, readOnly }) => {
  const policyNumber = orderSource?.policyNumber ?? form?.values?.policyNumber;
  const formAccount = normalizeOrderArFormAccount(form?.values?.arForm);
  const savedOrderAccount = normalizeOrderArFormAccount(orderSource?.arForm);
  const resolvedIfastAccountNo = resolveOrderIfastAccountNo({
    policyNumber,
    ifastAccountNo: readOnly
      ? savedOrderAccount.ifastAccountNo || formAccount.ifastAccountNo
      : formAccount.ifastAccountNo,
  });

  useEffect(() => {
    if (readOnly || !form) return;
    if (resolvedIfastAccountNo === formAccount.ifastAccountNo) return;
    setOrderIfastAccountNo(form, resolvedIfastAccountNo);
  }, [
    form,
    formAccount.ifastAccountNo,
    policyNumber,
    readOnly,
    resolvedIfastAccountNo,
  ]);

  const ifastAccountNo = resolvedIfastAccountNo;

  const handleIfastChange = (event) => {
    setOrderIfastAccountNo(form, event.currentTarget.value);
  };

  return (
    <Grid gutter="md">
      <Grid.Col span={12} md={6}>
        {readOnly ? (
          <SummaryItem
            label="iFAST A/C No. 奕豐戶口號碼"
            value={ifastAccountNo}
          />
        ) : (
          <TextInput
            label="iFAST A/C No. 奕豐戶口號碼"
            value={ifastAccountNo}
            onChange={handleIfastChange}
          />
        )}
      </Grid.Col>
    </Grid>
  );
};

export default OrderInvestmentAccount;
